import { cx } from '@linaria/core';
import { useRef } from 'react';
import { resets } from '@ui/css';
import { usePagination, Slider } from '@ui/kit';
import { Chevron } from '@utils/react';
import { AllLink } from '../../atoms/all-link.js';
import { heading } from '../../atoms/heading.style.js';
import { SliderItem } from './item.js';
import { wrapper, container, navButton, slider, allLink, article } from './slider.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function CardsSlider(props) {
  const containerRef = useRef(null);
  const sliderRef = useRef(null);
  const pagination = usePagination(props.cards, {
    sliderRef,
    infinite: true,
    type: "pages"
  });
  return /*#__PURE__*/jsx("article", {
    ref: containerRef,
    className: cx(resets.rootCls, article),
    children: /*#__PURE__*/jsxs("div", {
      className: wrapper,
      children: [/*#__PURE__*/jsx("h2", {
        className: heading,
        "data-alignment": props.options.titleAlignment ?? "center",
        children: props.meta.title
      }), /*#__PURE__*/jsxs("div", {
        className: container,
        children: [pagination.pageCount > 1 && /*#__PURE__*/jsx("button", {
          className: navButton,
          "aria-label": "G\xE5 tilbage",
          "data-direction": "backwards",
          tabIndex: -1,
          onClick: () => pagination.goBackwards(),
          children: /*#__PURE__*/jsx(Chevron, {
            size: 15,
            inversed: true
          })
        }), /*#__PURE__*/jsx(Slider, {
          wrapperRef: sliderRef,
          className: slider,
          pagination: pagination,
          items: props.cards,
          infinite: true,
          children: (item, {
            location
          }) => /*#__PURE__*/jsx(SliderItem, {
            card: item,
            locationInSlider: location,
            containerRef: containerRef
          })
        }), pagination.pageCount > 1 && /*#__PURE__*/jsx("button", {
          className: navButton,
          "aria-label": "G\xE5 fremad",
          "data-direction": "forwards",
          tabIndex: -1,
          onClick: () => pagination.goForwards(),
          children: /*#__PURE__*/jsx(Chevron, {
            size: 15
          })
        }), props.link && /*#__PURE__*/jsx(AllLink, {
          ...props.link,
          className: allLink
        })]
      })]
    })
  });
}

export { CardsSlider };
//# sourceMappingURL=slider.js.map
